import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  return _openBlock(), _createBlock(_component_el_select, {
    modelValue: $data.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.model = $event),
    placeholder: $props.placeholder,
    value: $props.value,
    onChange: _cache[1] || (_cache[1] = $event => _ctx.$emit('update:value', $event)),
    style: {
      "--el-border-radius-base": "20px"
    }
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.value,
        label: item.label,
        value: item.value
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "placeholder", "value"]);
}